export function toKebabCase(str?: string) {
    if (str == null) return str;
    return firstLowerCase(str).replace(/([A-Z])/g, "-$1").toLowerCase(); 
}

/**
 * Converts the first character to lower case. E.g. Example => example
 * @param str 
 */
export function firstLowerCase(str: string) {
    return str ? str[0].toLocaleLowerCase() + str.substring(1) : str;
}

/**
 * Converts the first character to upper case. E.g. Example => example
 * @param str 
 */
export function firstUpperCase(str: string) {
    return str ? str[0].toLocaleUpperCase() + str.substring(1) : str;
}

/**
 * Returns the sentence case (this is sentence case) representation of the given pascal/camel case string.
 * @param str The pascal/camel case string to return the sentence case representation of
 */
export function toSentenceCase(str: string) {
    return firstUpperCase(firstLowerCase(str).replace(/([A-Z])/g, " $1").toLowerCase()); 
}


/**
 * Returns the errormessage with the validation errormessage stripped
 * @param str The pascal/camel case string to return the sentence case representation of
 */
 export function WithoutValidationMessage(str: string) {
    var index = str.indexOf("Validation failed.");
   
    if (index>=0) {
        return str.substring( (index+"Validation failed.".length), str.length-index);
    }
    else {
        return str;
    }
}
